import { IStringifyOptions, stringify } from "qs";

/**
 * A helper to make parsing query params easier.
 * You provide a function which is given an instance of `URLSearchParams`.
 *
 * @example
 *
 * const params = parseSearchParams((x) => ({
 *   tab: x.get("tab") ?? "demographics",
 *   source: x.get("source") ?? "my-account",
 *   baseline: x.get("baseline") ?? "us-adults",
 * }));
 */
export const parseSearchParams = <T>(fn: (params: URLSearchParams) => T): T => {
  return fn(new URLSearchParams(window.location.search));
};

/**
 * Serializes an object to a query string.
 */
export const serializeQueryParams = (
  params: Record<string, unknown>,
  options: IStringifyOptions = {},
) => {
  return stringify(params, {
    ...options,
    addQueryPrefix: true,
    arrayFormat: "repeat",
  });
};
